<template>
    <div class="spin">
      <div style="position: absolute; left: 16px; top: 16px; display: flex; flex-direction: row; right: 16px;"> 
            <div>
              <img
                src="../assets/images/logo2.png"
                loading="lazy"
                style="height:100px;"
              />
            </div>
          <div style="display: flex; flex: 1; align-items: center; flex-end; justify-content: flex-end;">
              <div style="display: flex; align-items: center; gap: 8px; padding: 8px 16px; background: rgba(255, 107, 53, 0.15); border: 1px solid rgba(255, 107, 53, 0.4); border-radius: 50px; backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);">
                  <img src="../assets/images/coin.png" width="22" alt="Coin" />
                  <span style="font-family: 'Poppins', sans-serif; font-size: 14px; font-weight: 700; color: #FF9165; text-shadow: 0 0 10px rgba(255, 145, 101, 0.5);">{{ mycoin }}</span>
                </div>
                <span class="avatar" id="avatar" :style="{ 'background-image': `url(${pictureUrl})` }"></span>
          </div> 
      </div>
      <div style="position: absolute; top: 30%; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
        <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
          <div style="border-radius: 50px; margin-left: 0px; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;"  v-if="showLoading">
            <vue-scratchable
              v-slot="{ init }"
              :brushOptions="brush"
              :hideOptions="hide"
              getPercentageCleared
              @percentage-update="updatePoints"
            >
            <div class="wrapper">
              <img
                :src="require('../assets/images/7coin.png')"
                @load="init()"
              >
            </div>
            <h3 style="color:transparent">🎉 คุณได้รับ {{coin}} เหรียญยินดีด้วยนะคะ 🎉</h3>
          </vue-scratchable>
          </div>
          <div style="border-radius: 50px; margin-left: 0px; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;"  v-else>
            <img
                :src="require('../assets/images/aladin.jpg')"
              >
          </div>
        </div>
      </div>
      <div style="position: absolute; top: 70%; align-items: center; justify-content: center; display: flex; left: 0; right: 0;" v-if="showLoading"><h3 class="glow">{{subline}}</h3></div>
      <!-- <div style="position: absolute; bottom: 10px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
      <lottie :options="defaultOptions" :height="300" :width="300" :speed="2" v-on:animCreated="handleAnimation"/>
      </div> -->
      <div style="position: absolute; bottom: 20px; align-items: center; justify-content: center; display: flex; left: 0; right: 0;">
            <div style="display: flex; flex: 1; align-items: center; justify-content: center;">
                  <div style="border-radius: 50px; margin-left: 0px; background: #2f2f2f; align-items: center; justify-content: center; display: flex; padding-left: 16px; padding-right: 16px; padding-top: 9px; padding-bottom: 9px;">
                      <span class="glow" ref="myBtn">
                        {{loadingtext}}
                      </span>
                  </div>
              </div> 
      </div>
      <div>
      
      </div>
  </div>
</template>

<script>
import firebase, { firestore } from "firebase/app";
import "firebase/database";
import moment from "moment-timezone";
import VueScratchable from '../components/vue-scratchable.vue';
import paperPattern from '../assets/images/natural-paper-texture.jpg';
import router from "./../router";
import liffService from "@/services/liff";
//import Lottie from './lottie.vue';
//import * as animationData from '../assets/aladin.json';
export default {
  name: 'S1',
  created(){
	  // const animate = animationData.default;
    // this.defaultOptions = {animationData: animate,autoplay:true,loop:true};
  },
  components: {
    VueScratchable,
    // 'lottie': Lottie
  },
  computed: {
    subline() {
      if(this.percentage === 0) return `ขูด ๆ ถู ๆ ได้เลยค่ะ`;
      return this.percentage < 50
        ? `ขูด ๆ ถู ๆ อีกนิดนะ`
        : '💚 ยินดีด้วยคุณได้รับ '+this.coin+' เหรียญ 💚';
    },
  },
  data() {
    return {
      coin:14,
      pictureUrl:'',
      mycoin:0,
      showLoading:false,
      isDisabled: true,
      percentage: 0,
      hide: {
        type: 'pattern',
        src: paperPattern,
        repeat: 'repeat',
      },
      brush: {
        size: 20,
        shape: 'round',
      },
      loadingtext:'น้องออโต้กำลังประมวลผลให้อยู่ค่ะ รอสักครู่',
      defaultOptions: null,
    };
  },
  mounted() {
      //this.anim.play();
      // LIFF is already initialized by router guard
      this.loadUserData();
      setTimeout(() => {
        this.showLoading = false;
      }, 3000);
  },
  methods: {
    // handleAnimation: function (anim) {
    //       this.anim = anim;
    // },
    updatePoints(percentage) {
      this.percentage = percentage;
      if(this.percentage > 50){
        firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).set({
          userId:this.userId,
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          spin:this.coin,
          value:this.coin
        });
        this.$confirm(
					{
						message: `🧽 ปังปุรีเย่!! คุณได้รับ ${this.coin} เหรียญ😘😘`,
						button: {
						yes: 'OK'
						},
						callback: async (confirm) => {
							if (confirm) {
								this.sendMessageLine3(this.coin+' เหรียญ');
							}
						}
					}
        );	
      }
    },
    async sendMessageLine(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🧽 "+text,
          }
      ]);
      window.liff.closeWindow();
    },
    async sendMessageLine2(text){
      await window.liff.sendMessages([
          {
              "type": "text",
              "text": "🧽 "+text,
          },
      ]);
    },
    async sendMessageLine3(text){
      await window.liff.sendMessages([{
        "type": "flex",
        "altText": 'ปังปุรีเย่!! คุณได้รับ '+text,
        "contents": {
              "type": "bubble",
              "size": "micro",
              "body": {
                "type": "box",
                "layout": "vertical",
                "contents": [
                  {
                    "type": "text",
                    "text": "ยินดีด้วยค่ะ !",
                    "color": "#CCCCCC",
                    "size": "lg",
                    "weight": "bold",
                    "align": "center"
                  },
                  {
                    "type": "image",
                    "url": "https://firebasestorage.googleapis.com/v0/b/ufs896vip/o/coupon%2Fcoin.png?alt=media",
                    "position": "relative",
                    "size": "sm"
                  },
                  {
                    "type": "text",
                    "text": "+"+text,
                    "size": "sm",
                    "color": "#CCCCCC",
                    "align": "center",
                    "weight": "bold"
                  }
                ],
                "spacing": "xxl",
                "margin": "none",
                "action": {
                  "type": "uri",
                  "label": "action",
                  "uri": "https://liff.line.me/2006378234-72e9GVNa/reward",
                  "altUri": {
                    "desktop": "https://liff.line.me/2006378234-72e9GVNa/reward"
                  }
                },
                "background": {
                  "type": "linearGradient",
                  "angle": "0deg",
                   "startColor": "#f56991",
                   "endColor": "#7367f0"
                }
              },
              "styles": {
                "footer": {
                  "separator": true
                }
              }
            }
          }]);
      window.liff.closeWindow();
    },
    async loadUserData() {
      if (!window.liff.isInClient()) {
          router.replace("/login");
      }else{
          // Get profile from centralized service (already fetched by router guard)
          const profile = liffService.profile;
          if (!profile) return;

          this.userId = profile.userId || "";
          this.pictureUrl = profile.pictureUrl || "none";
          if (this.userId) {
              const user = (await firebase.database().ref(`/users`).orderByChild('userId').equalTo(this.userId).once("value")).val();
              if (user) {
                  const u = user[Object.keys(user)[0]];
                  this.mycoin = (u.coins)?u.coins:0;
                  this.userKey = Object.keys(user)[0];
                  this.sendMessageLine2("สนใจ ขูดๆ ถูๆ พลอยใสจัดการให้หน่อย 😘😘");
                  if(moment().tz("Asia/Bangkok").format("YYYY-MM-DD") === '2026-03-26') {
                    await firebase.firestore().collection('scratch').doc(this.userId+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then(async (snapshot) => {
                      if(snapshot.exists) {
                          this.sendMessageLine("ลูกค้า ขูดๆ ถูๆไปแล้วนะคะวันนี้ รอวันพรุ่งนี้นะคะ 😘😘");
                      }else{
                        await firebase.firestore().collection('history').where('userId','==',this.userId).where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('createdate','>=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 18:00:00').where('createdate','<=',moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 23:59:59').get().then(async (snapshot) => {
                          let credit = 0;
                          snapshot.forEach((doc)=>{
                            credit += Number(doc.data().qty);
                          });
                          if(credit >= 250){
                            this.loadingtext = 'น้องออโต้พร้อมแล้ว ขูดๆ ถูๆ ได้เลยค่ะ😘😘';
                            this.showLoading = true;
                          }else{
                            const less = 250-Number(credit);
                            this.loadingtext = `เติมเงินอีก ${less}(250) ได้เล่นเลยค่ะ!😘😘`;
                          }
                        });
                      }
                    });
                  }else{
                    this.loadingtext = `กิจกรรมนี้เฉพาะวันที่ 26 March เท่านั้น!😘😘`;
                  }
              }else{
                router.replace("/register");
              }
          }
          this.isDisabled = false;
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  padding-left: 20%;
}
.center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
        padding-top: 50%;
        height: 100%;
      }
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
    
    to {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
}
/* body {
  background-color: #333;
  margin: 0;
}

#app {
  font-family: 'Open Sans', sans-serif;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}

.vue-scratchable-wrapper {
  background-color: white;
}

h3 {
  color: #2c3e50;
  text-align: center;
}

a {
  color: #2196f3;
} */
.spin {   padding: 0px;
          margin: 0px;
          overflow: hidden;
          height: 100%;
background: rgb(255,204,92,1);
background: radial-gradient(circle, rgba(255,204,92,1) 49%, rgba(34,193,195) 100%);
          background: linear-gradient(#0f032b, #6035c2);
          border-right: 2px solid #cbcbcb;
         /* background-image: url("../assets/images/halloween.jpg");*/
          background-position: center; /* Center the image */
          background-repeat: no-repeat; /* Do not repeat the image */
          background-size: cover; 
      }
      .center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        width: 80%;
        padding-top: 50%;
        height: 100%;
      }
</style>